import { render, staticRenderFns } from "./SelectNodeField.vue?vue&type=template&id=a83d7ba4&lang=pug&"
import script from "./SelectNodeField.vue?vue&type=script&lang=js&"
export * from "./SelectNodeField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a83d7ba4')) {
      api.createRecord('a83d7ba4', component.options)
    } else {
      api.reload('a83d7ba4', component.options)
    }
    module.hot.accept("./SelectNodeField.vue?vue&type=template&id=a83d7ba4&lang=pug&", function () {
      api.rerender('a83d7ba4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inspector/fields/SelectNodeField.vue"
export default component.exports